import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase";

const IconBack = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="bk" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#bk)">
      <path d="M11.625 15.7917L5.83333 10L11.625 4.20833L12.8125 5.39583L8.20833 10L12.8125 14.6042L11.625 15.7917Z" fill="#111111"/>
    </g>
  </svg>
);

export default function PaymentHistoryPage({ user }) {
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      if (!user?.id) return;
      const { data } = await supabase
        .from('payment_history')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false });
      if (data) setHistory(data);
      setLoading(false);
    };
    load();
  }, [user]);

  const formatDate = (str) => {
    const d = new Date(str);
    return `${d.getFullYear()}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getDate()).padStart(2,'0')}`;
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f0f0f0', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 430, background: '#ffffff', minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: "'DM Mono', monospace" }}>

        <div style={{ background: '#ffffff', borderBottom: '1px solid #111111', height: 52, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px', flexShrink: 0 }}>
          <button onClick={() => navigate('/my')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}>
            <IconBack />
          </button>
          <span style={{ fontSize: 15, fontWeight: 600, color: '#111111', letterSpacing: 1 }}>결제내역</span>
          <div style={{ width: 20 }} />
        </div>

        <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 10, flex: 1 }}>
          {loading && (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ width: 16, height: 16, border: '2px solid #bbbbbb', borderTopColor: '#111111', borderRadius: '50%', display: 'inline-block', animation: 'spin .7s linear infinite' }} />
              <style>{`@keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
            </div>
          )}

          {!loading && history.length === 0 && (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 15, color: '#888888', marginBottom: 8 }}>결제 내역이 없어요</div>
                <button onClick={() => navigate('/payment')}
                  style={{ background: '#111111', color: '#ffffff', border: 'none', borderRadius: 8, padding: '11px 20px', fontSize: 15, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
                  말풍선 충전하기
                </button>
              </div>
            </div>
          )}

          {!loading && history.length > 0 && (
            <div style={{ background: '#ffffff', border: '1px solid #111111', borderRadius: 12, overflow: 'hidden' }}>
              <div style={{ background: '#111111', color: '#ffffff', padding: '9px 14px', fontSize: 15, fontWeight: 600, letterSpacing: 1, borderRadius: '12px 12px 0 0' }}>결제 내역</div>
              {history.map((item, i) => (
                <div key={item.id} style={{ padding: '14px', borderBottom: i < history.length - 1 ? '1px solid #eeeeee' : 'none' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: '#111111' }}>{item.package_name} 패키지</span>
                    <span style={{ fontSize: 15, fontWeight: 700, color: '#111111' }}>{item.amount?.toLocaleString()}원</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 13, color: '#888888' }}>💬 {item.package_count}개 · {item.payment_method}</span>
                    <span style={{ fontSize: 13, color: '#bbbbbb' }}>{formatDate(item.created_at)}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}